export default __webpack_public_path__ + "static/media/delivery-truck.64068869.png";